import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: {},
    token: "",
    pagePermission: {},
  },
  reducers: {
    updateUser(state, action) {
      state.user = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
    clearUser(state) {
      console.log("🚀 ~ clearUser ~ clearUser:");
      state.user = {};
      state.token = "";
    },
    setPagePermissions(state, action) {
      console.log("🚀 ~ setPagePermissions ~ action.payload:", action.payload);
      state.pagePermission = action.payload;
    },
  },
});

export const userAction = userSlice.actions;
export default userSlice;
